import type { Hook } from '../types';

export function triggerLegendUpdater(...args: Parameters<Hook['triggerLegendUpdater']>) {
  const [chartIns, legendIns] = args;
  if (!chartIns || !legendIns) {
    return;
  }

  legendIns.on('legendClick', e => {
    const ecIns = chartIns.getECharts();
    ecIns.dispatchAction({
      type: 'legendToggleSelect',
      name: e.data.name
    });
  });
}
